import get from "lodash.get";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Button from "../components/Button";
import Form from "../components/Form";
import InputCheckbox from "../components/InputCheckbox";
import Modal from "../components/Modal";
import { useContractQuery } from "../hooks";

const SubmitRenewalBespokeForm = ({ contractData, formData, handleConfirm, handleClose }) => {
  const [formValues, setFormValues] = useState({});
  const bespokeEndos = get(contractData, "bespoke_endorsements", []);

  const handleSubmit = async () => {
    const nextBespokeEndos = bespokeEndos.filter((bespokeEndo) => formValues[bespokeEndo.id]);

    handleClose();
    handleConfirm(formData, nextBespokeEndos);
  };

  return (
    <div className="p-6">
      <Form onSubmit={handleSubmit}>
        <div className="mb-8">
          {bespokeEndos.map((bespokeEndo) => (
            <div className="mb-8" key={bespokeEndo.id}>
              <InputCheckbox
                isChecked={formValues[bespokeEndo.id]}
                labelText={bespokeEndo.ref}
                name={bespokeEndo.ref}
                onChange={() =>
                  setFormValues({ ...formValues, [bespokeEndo.id]: !formValues[bespokeEndo.id] })
                }
              />
              <p className="mt-4">{bespokeEndo.content}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-end">
          <Button onClick={handleClose}>Cancel</Button>

          <Button className="ml-4" kind="primary" type="submit">
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};

const SubmitRenewalBespokeModal = ({ handleClose, formData, handleConfirm }) => {
  const { contractData, isLoading } = useContractQuery();

  return (
    <Modal
      handleClose={handleClose}
      headingText="Select bespoke endorsements to include"
      isLoading={isLoading}
    >
      <SubmitRenewalBespokeForm
        contractData={contractData}
        formData={formData}
        handleConfirm={handleConfirm}
        handleClose={handleClose}
      />
    </Modal>
  );
};

SubmitRenewalBespokeModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default SubmitRenewalBespokeModal;
